export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderError@3x.png";